import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AnimatePresence } from 'framer-motion';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { OpenAccount } from './pages/OpenAccount';
import { Privacy } from './pages/Privacy';
import { RestrictedJurisdictions } from './pages/RestrictedJurisdictions';
import { ROUTES } from './utils/constants';
import Analytics from './utils/analytics';

function AnimatedRoutes() {
  const location = useLocation();

  // Track page views
  useEffect(() => {
    Analytics.trackPageView(location.pathname);
  }, [location]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path={ROUTES.HOME} element={<Home />} />
        <Route path={ROUTES.OPEN_ACCOUNT} element={<OpenAccount />} />
        <Route path={ROUTES.PRIVACY} element={<Privacy />} />
        <Route path={ROUTES.RESTRICTED_JURISDICTIONS} element={<RestrictedJurisdictions />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  // Initialize analytics on app load
  useEffect(() => {
    Analytics.initGA4();
    Analytics.initMetaPixel();
  }, []);

  return (
    <BrowserRouter>
      <Layout>
        <AnimatedRoutes />
      </Layout>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#2a2a2a',
            color: '#e0e0e0',
            border: '1px solid #3a3a3a',
            fontSize: '14px',
          },
          success: {
            iconTheme: {
              primary: '#4ade80',
              secondary: '#2a2a2a',
            },
          },
          error: {
            iconTheme: {
              primary: '#f87171',
              secondary: '#2a2a2a',
            },
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
